import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import DashboardPage from './DashboardPage';

type TParams = { id: string, url: string }

function Dashboard({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={DashboardPage} />
        </Switch>
    );
}

export default Dashboard;
